import { AppThunk } from '../../../store/rootReducer';
import { manualAbnormalitiesSelector } from '../selectors/user-diagnostic.selectors';
import { Abnormality } from '../types/diagnostic';
import * as diagnosticActions from '../actions/diagnostic.actions';

export const savePrimaryAbnormalities =
  (primaryAbnormalities: Abnormality[]): AppThunk =>
  async (dispatch, getState) => {
    const manualAbnormalities = manualAbnormalitiesSelector(getState());
    const abnormalities = primaryAbnormalities.concat(manualAbnormalities);

    dispatch(
      diagnosticActions.setAbnormalities({
        abnormalities,
      }),
    );
  };
